/// <amd-module name="Wiki/NoWiki/WikiNoPermission" />
import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { IZeroDataItem, ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";

import { TelemetryConstants } from "Wiki/ViewCommon/CustomerIntelligenceConstants";
import { publish } from "Wiki/ViewCommon/Utils/WikiHelper";

export interface WikiNoPermissionProps {
    /**
     * Primary text for the No permission component
     */
    primaryText: string;
    /**
     * Text to put on the CTA.
     */
    actionText?: string;
    /**
     * The type of button to render. Default is CTA button.
     */
    actionType?: ZeroDataActionType;
    /**
     * Callback called when the user clicks on the button
     */
    onActionClick?: (ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item?: IZeroDataItem) => void;
    /**
     * href used for link when actionType is link
     */
    actionHref?: string;
}

export class WikiNoPermission extends VssComponent<WikiNoPermissionProps> {
    public componentDidMount(): void {
        super.componentDidMount();
        publish(this.context.pageContext, TelemetryConstants.LandingPageInSufficientReadPermissionScreen);
    }

    public render(): JSX.Element {
        return (
            <div className={"wiki-nowiki flex-column justify-center"}>
                <ZeroData
                    primaryText={this.props.primaryText}
                    imagePath={getAssetLocation(this.context.pageContext, "ms.vss-wiki-web/wiki-nowiki-experience/Images/wiki-no-permission.svg")}
                    imageAltText=""
                    actionText={this.props.actionText}
                    actionType={this.props.actionType}
                    actionHref={this.props.actionHref}
                    onActionClick={this.props.onActionClick}
                />
            </div>
        );
    }
}
